<template>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <div class="px-6 surface-overlay relative">
        <div v-show="this.companyConfiguration.enableEmailChange === 'Y'" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Configuration</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Email Information</a></li>
                    </ul>

                    <div v-show="oAuth2CallbackStatus === 'SUCCESS'" class="text-green-900 text-xl font-bold">
                        Successfully authenticated with your external mail provider!
                    </div>
                    <div v-show="oAuth2CallbackStatus === 'ERROR'" class="text-red-900 text-xl font-bold">
                        Failed to authenticate with your external mail provider!
                    </div>

                    <h3>Manage Email Setup</h3>

                    <div class="field">
                        <label for="mode">Mode</label>
                        <Dropdown id="mode" v-model="companyConfiguration.mailServerMode" :options="mailServerModes" optionLabel="name" optionValue="code"
                                  placeholder="Select a Mode"/>
                    </div>

                    <div v-show="companyConfiguration.mailServerMode === 'D'" class="field">
                        <label for="mailServerHost">Mail Server Host</label>
                        <InputText id="mailServerHost" type="text" :disabled="false"
                                   v-model.trim="companyConfiguration.mailServerHost"/>
                    </div>

                    <div v-show="companyConfiguration.mailServerMode === 'D'" class="field">
                        <label for="mailServerPort">Mail Server Port</label>
                        <InputText id="mailServerPort" type="text" :disabled="false"
                                   v-model.trim="companyConfiguration.mailServerPort"/>
                    </div>

                    <div v-show="companyConfiguration.mailServerMode === 'D'" class="field">
                        <label for="mailServerUsername">Mail Server Username</label>
                        <InputText id="mailServerUsername" type="text" :disabled="false"
                                   v-model.trim="companyConfiguration.mailServerUsername"/>
                    </div>

                    <div v-show="companyConfiguration.mailServerMode === 'D'" class="field">
                        <label for="mailServerPassword">Mail Server Password</label>
                        <InputText id="mailServerPassword" type="password" :disabled="false"
                                   v-model.trim="companyConfiguration.mailServerPassword"/>
                    </div>

                    <div v-show="companyConfiguration.mailServerMode === 'D'" class="field">
                        <label for="mailServerSenderName">Mail Server Sender Name</label>
                        <InputText id="mailServerSenderName" type="text" :disabled="false"
                                   v-model.trim="companyConfiguration.mailServerSenderName"/>
                    </div>

                    <div v-show="companyConfiguration.mailServerMode === 'D'" class="field">
                        <label for="mailServerAuth">Mail Server Authentication?</label>
                        <Dropdown v-model="companyConfiguration.mailServerAuth" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div v-show="companyConfiguration.mailServerMode === 'D'" class="field">
                        <label for="mailServerStartTls">Mail Server Start TLS?</label>
                        <Dropdown v-model="companyConfiguration.mailServerStartTls" :options="confirmationTypes"
                                  optionLabel="name"
                                  optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div v-show="companyConfiguration.mailServerMode === 'G'" class="field">
                        <label>Gmail Address</label>
                        <div class="card p-fluid">
                            <span class="text-600 font-bold">
                                {{ oauth2Configuration.email }}
                            </span>
                        </div>
                    </div>

                    <div v-show="companyConfiguration.mailServerMode === 'G'" class="field">
                        <label>Gmail OAuth2 Credential </label>

                        <div v-show="oauth2Configuration.hasOAuth2Credential === 'Y'" class="card p-fluid">
                            <span class="text-green-600 font-bold">
                                Credentials found
                            </span>
                            <Button label="Delete Credentials" class="mr-2 mb-2" @click="deleteOAuth2Credential"></Button>
                        </div>
                        <div v-show="oauth2Configuration.hasOAuth2Credential === 'N'" class="card p-fluid">
                            <span class="text-red-600 font-bold">
                                No credentials found
                            </span>
                            <img src="images/google/btn_google_signin_dark_normal_web.png" alt="Sign in with Google" style="display: block;" class="mr-2 mb-2" @click="authenticateOAuth2" />
                        </div>
                    </div>

                    <div v-show="companyConfiguration.mailServerMode === 'M'" class="field">
                        <label>Microsoft OAuth2 Credential</label>

                        <div v-show="entraOauth2Configuration.hasOAuth2Credential === 'Y'" class="card p-fluid">
                            <span class="text-green-600 font-bold">
                                Credentials found
                            </span>
                            <Button label="Delete Credentials" class="mr-2 mb-2" @click="deleteEntraOAuth2Token"></Button>
                        </div>
                        <div v-show="entraOauth2Configuration.hasOAuth2Credential === 'N'" class="card p-fluid">
                            <span class="text-red-600 font-bold">
                                No credentials found
                            </span>
                            <img src="images/ms/signin_light.png" alt="Sign in with Microsoft" style="display: block;" class="mr-2 mb-2" @click="doEntraOAuth2" />
                        </div>
                    </div>

                    <div class="field">
                        <label for="emailSignature">Email Signature</label>
                        <Editor v-model="companyConfiguration.emailSignature" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                  <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                  <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                  <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                  <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                  <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                  <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                  <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                  <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                  <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                  <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <Button label="Save" class="mr-2 mb-2" @click="updateConfiguration"></Button>

                </div>
            </div>
        </div>


        <div v-show="this.companyConfiguration.enableEmailChange === 'N'" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Email Configuration</h3>

                    <div class="field">
                        <label for="mailServerUsername">Mail Server Username</label>
                        <InputText id="mailServerUsername" type="text" :disabled="true"
                                   v-model.trim="companyConfiguration.mailServerUsername"/>
                    </div>

                    <div class="field">
                        <label for="mailServerSenderName">Mail Server Sender Name</label>
                        <InputText id="mailServerSenderName" type="text"
                                   v-model.trim="companyConfiguration.mailServerSenderName"/>
                    </div>

                    <div class="field">
                        <label for="emailSignature">Email Signature</label>
                        <Editor v-model="companyConfiguration.emailSignature" editorStyle="height: 250px">
                            <template v-slot:toolbar>
                                <span class="ql-formats">
                                  <button class="ql-bold" v-tooltip.bottom="'Bold'"></button>
                                  <button class="ql-italic" v-tooltip.bottom="'Italic'"></button>
                                  <button class="ql-underline" v-tooltip.bottom="'Underline'"></button>
                                  <button class="ql-strike" v-tooltip.bottom="'Strike'"></button>
                                  <button class="ql-color" v-tooltip.bottom="'Color'"></button>
                                  <button class="ql-background" v-tooltip.bottom="'Color'"></button>
                                  <button class="ql-list" value="bullet" v-tooltip.bottom="'Bulleted List'"></button>
                                  <button class="ql-list" value="ordered" v-tooltip.bottom="'Ordered List'"></button>
                                  <button class="ql-indent" value="-1" v-tooltip.bottom="'Indent -1'"></button>
                                  <button class="ql-indent" value="+1" v-tooltip.bottom="'Indent +1'"></button>
                                </span>
                            </template>
                        </Editor>
                    </div>

                    <Button label="Save" class="mr-2 mb-2" @click="updateConfiguration"></Button>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import CompanyService from "@/service/CompanyService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
            companyConfiguration: {},
            oauth2Configuration: {},
            entraOauth2Configuration: {},
            oAuth2CallbackStatus: null,
            mailServerModes: [
                {name: 'Dedicated Mail Server', code: 'D'},
                {name: 'Microsoft Account', code: 'M'},
                {name: 'Gmail Account', code: 'G'}
            ],
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ]
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;

            try {
                const [userConfigData] = await Promise.all([
                    UserService.getUserConfig(this.userStore.user.id)
                ]);

                this.userConfiguration = userConfigData.data;
                console.log("[PhoneCalls][mounted] userConfigData.data = ", userConfigData.data);
            } catch (e) {
                console.error("[PhoneCalls][mounted] Could not find user config for user = ", this.userStore.user.id);
            }

            try {
                const [companyConfigData] = await Promise.all([
                    CompanyService.getCompanyConfiguration(this.profile.companyId)
                ]);

                this.companyConfiguration = companyConfigData.data;
                console.log("[PhoneCalls][mounted] companyConfigData.data = ", companyConfigData.data);

            } catch (e) {
                console.error("[PhoneCalls][mounted] Error fetching additional data = ", e);
            }

            console.log("[PhoneCalls][mounted] this.userConfiguration = ", this.userConfiguration);
            console.log("[PhoneCalls][mounted] this.companyConfiguration = ", this.companyConfiguration);

            try {
                const [response] = await Promise.all([
                    CompanyService.hasOAuth2Credential(this.profile.companyId)
                ]);

                this.oauth2Configuration = response.data.data;
            } catch (e) {
                console.error("[ConfigurationEmail][mounted] Error fetching oauth2 credential data = ", e);
            }

            try {
                const [response] = await Promise.all([
                    CompanyService.hasEntraOAuth2Token(this.profile.companyId)
                ]);

                this.entraOauth2Configuration = response.data.data;
            } catch (e) {
                console.error("[ConfigurationEmail][mounted] Error fetching entra oauth2 credential data = ", e);
            }

            // if ( (this.profile.companyId === 1) || (this.profile.companyId === 114951) || (this.profile.companyId === 119787)) {
            //     var mailServerGmailOption = {name: 'Gmail Account', code: 'G'};
            //
            //     this.mailServerModes.push(mailServerGmailOption);
            // }

            if (this.$route.query.oAuth2CallbackStatus) {
                this.oAuth2CallbackStatus = this.$route.query.oAuth2CallbackStatus;
                console.log('Found this.oAuth2CallbackStatus = ', this.oAuth2CallbackStatus)
            }

            console.log("[ConfigurationEmail][mounted] hasOAuth2Credential oauth2Configuration = ", this.oauth2Configuration);
        },
        async updateConfiguration() {

            var updatedConfiguration = {
                mailServerMode: this.companyConfiguration.mailServerMode,
                mailServerHost: this.companyConfiguration.mailServerHost,
                mailServerPort: this.companyConfiguration.mailServerPort,
                mailServerUsername: this.companyConfiguration.mailServerUsername,
                mailServerPassword: this.companyConfiguration.mailServerPassword,
                mailServerSenderName: this.companyConfiguration.mailServerSenderName,
                mailServerAuth: this.companyConfiguration.mailServerAuth,
                mailServerStartTls: this.companyConfiguration.mailServerStartTls,
                emailSignature: this.companyConfiguration.emailSignature
            };

            console.log("[" + name + "][processUpdateConfiguration] Updated configuration. Data = ", updatedConfiguration);

            this.activeTab = 2;

            try {
                // Delete the appointment
                const response = await CompanyService.updateCompanyConfiguration(this.profile.companyId, updatedConfiguration);
                console.log('[PhoneCalls][deletePhoneCall] Response = ', response);

                const [companyConfigData] = await Promise.all([
                    CompanyService.getCompanyConfiguration(this.profile.companyId)
                ]);

                this.companyConfiguration = companyConfigData.data;
                console.log("[PhoneCalls][mounted] companyConfigData.data = ", companyConfigData.data);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Configuration updated',
                    life: 3000
                });

            } catch (error) {
                console.error('[PhoneCalls][deletePhoneCall] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update configuration. Please try again.',
                    life: 3000
                });
            }

        },
        async authenticateOAuth2() {
            try {
                const [response] = await Promise.all([
                    CompanyService.authenticateOAuth2(this.profile.companyId)
                ]);
                console.log("[ConfigurationEmail][authenticateOAuth2] data = ", response.data);

                // redirect
                if (response.data.data.url) {
                    window.top.location.href = response.data.data.url;
                }
            } catch(error) {
                console.error('[ConfigurationEmail][authenticateOAuth2] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to start google authentication process. Please try again.',
                    life: 3000
                });
            }
        },
        async deleteOAuth2Credential() {
            try {
                const [response] = await Promise.all([
                    CompanyService.deleteOAuth2Credential(this.profile.companyId)
                ]);
                console.log("[ConfigurationEmail][deleteOAuth2Credential] response  = ", response);

                const [response2] = await Promise.all([
                    CompanyService.hasOAuth2Credential(this.profile.companyId)
                ]);

                this.oauth2Configuration = response2.data.data;
            } catch(error) {
                console.error('[ConfigurationEmail][deleteOAuth2Credential] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to delete google authentication credentials. Please try again.',
                    life: 3000
                });
            }
        },
        async doEntraOAuth2() {
            try {
                const [response] = await Promise.all([
                    CompanyService.entraGetAuthUrl(this.profile.companyId)
                ]);
                console.log("[ConfigurationEmail][doEntraOAuth2] data = ", response.data);

                // redirect
                if (response.data.data.url) {
                    window.top.location.href = response.data.data.url;
                }
            } catch(error) {
                console.error('[ConfigurationEmail][doEntraOAuth2] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to start microsoft authentication process. Please try again.',
                    life: 3000
                });
            }
        },
        async deleteEntraOAuth2Token() {
            try {
                const [response] = await Promise.all([
                    CompanyService.deleteEntraOAuth2Token(this.profile.companyId)
                ]);
                console.log("[ConfigurationEmail][deleteEntraOAuth2Token] response  = ", response);

                const [response2] = await Promise.all([
                    CompanyService.hasEntraOAuth2Token(this.profile.companyId)
                ]);

                this.entraOauth2Configuration = response2.data.data;
            } catch(error) {
                console.error('[ConfigurationEmail][deleteEntraOAuth2Token] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to delete microsoft authentication credentials. Please try again.',
                    life: 3000
                });
            }
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
